import type { WindowLocation } from "@reach/router";

export const onRouteUpdate = ({ location }: { location: WindowLocation }) => {
  if (location.hash) {
    const el = document.querySelector(location.hash);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      return;
    }
  }

  requestAnimationFrame(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  })
};